export default function auth({ next, store, to }) {
    if (!store.getters.auth) {
        return next({
            name: 'Login'
        })
    }
    //Restriction Report
    /* if (to.path.startsWith('/report')) {
        const emailsInterdits = ['freelance1@weedoit.fr', 'freelance2@weedoit.fr'];
        if (
            (JSON.parse(localStorage.getItem('utilisateur')).law == 'ad' ||
            JSON.parse(localStorage.getItem('utilisateur')).law == 'tem' ||
            JSON.parse(localStorage.getItem('utilisateur')).law == 'ma') &&
            !emailsInterdits.includes(JSON.parse(localStorage.getItem('utilisateur')).email)
        ) {
            return next()
        }else{
            return next({
                name: 'Dashboard layout'
            })
        }
    } */

    if (to.path.startsWith('/report')) {
        const emailsAccess = [
            'k.ghalem@weedoit.fr',
            's.boukbir@weedoit.fr',
            'a.gorani@weedoit.fr',
            'h.elkhou@weedoit.fr',
            'a.jawhara@eca-assurances.com',
            'h.bouderbala@eca-assurances.com',
            's.radoine@weedoit.fr',
            'm.mouret@eca-assurances.com',
            'emilie.ambiaux@gmail.com',
            'n.khallouki@weedoit.fr'
        ];
        const emailsAccessLowerCase = emailsAccess.map(email => email.toLowerCase());
        if (emailsAccessLowerCase.includes(JSON.parse(localStorage.getItem('utilisateur')).email.toLowerCase())) {
            return next()
        } else {
            return next({
                name: 'Dashboard layout'
            })
        }
    }

    if (
        JSON.parse(localStorage.getItem('utilisateur')).law == 'ad' ||
        JSON.parse(localStorage.getItem('utilisateur')).law == 'tem' ||
        JSON.parse(localStorage.getItem('utilisateur')).law == 'ma'
    ) {
        return next()
    } else if (JSON.parse(localStorage.getItem('utilisateur')).law == 'an') {
        return next({
            name: 'Annonceur Dashboard'
        })
    }
    return next({
        name: 'Editeur Dashboard'
    })

}
